import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "upload_body"
};
const _hoisted_2 = {
  class: "upload_body_nr"
};
const _hoisted_3 = {
  class: "tabLists"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "upload_list"
};
const _hoisted_6 = {
  key: 0,
  style: {
    "width": "347px"
  },
  src: "https://www.mimodental.com/assets/imgData/img/member_preferential/empty.png"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "img_div"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "text"
};
const _hoisted_11 = {
  style: {
    "margin-bottom": "20px"
  }
};
const _hoisted_12 = {
  style: {
    "display": "block",
    "text-indent": "32px"
  }
};
const _hoisted_13 = {
  style: {
    "color": "#999"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tabList, (item, index) => {
    return _openBlock(), _createElementBlock("span", {
      key: index,
      style: _normalizeStyle('color:' + ($setup.tabIndex == index ? '#23A5C8;' : '#000;')),
      onClick: $event => $setup.tabClick(index)
    }, _toDisplayString(item.name), 13, _hoisted_4);
  }), 128))]), _createElementVNode("div", _hoisted_5, [$setup.upList.length == 0 ? (_openBlock(), _createElementBlock("img", _hoisted_6)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.upList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      onClick: $event => $setup.go(item.id)
    }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
      src: item.imgUrl,
      alt: ""
    }, null, 8, _hoisted_9)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", null, [_createElementVNode("h3", _hoisted_11, _toDisplayString(item.title), 1), _createElementVNode("span", _hoisted_12, _toDisplayString(item.brief), 1), _createElementVNode("span", _hoisted_13, _toDisplayString(item.customTime), 1)]), _cache[0] || (_cache[0] = _createElementVNode("div", {
      class: "item_r_b"
    }, [_createElementVNode("span", null, "了解详情")], -1))])], 8, _hoisted_7);
  }), 128))])])]);
}